var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1668.56 1221.19"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7 0 0 1.7 -600 -400)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 834.28,
    cy: 610.6,
    r: 481.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "m485.39 356.79 230.07 307.62-231.52 250.11h52.11l202.7-218.98 163.77 218.98h177.32L836.82 589.6l215.5-232.81h-52.11L813.54 558.46 662.71 356.79zm76.63 38.38h81.46l359.72 480.97h-81.46z",
    style: {
      fill: "#fff"
    },
    transform: "translate(52.39 -25.059)"
  })));
};
export default SvgTwitter;